import React from 'react';
import './Styles/Banner.scss';
import Carousel from 'react-elastic-carousel';
import image1 from '../../../Assets/Backgrounds/aboutSmallimg.webp';
import image2 from '../../../Assets/Backgrounds/boxBg.webp';

import {ReactComponent as Play} from '../../../Assets/Icons/sliderPlay.svg';


const breakPoints = [
    { width: 1, itemsToShow: 1 }
];

export const slides = [
    image1,image2
]
const Banner=()=>{
    return(
        <div className="customer-banner">
            <h1 data-aos="zoom-in"
              data-aos-delay={100}>HostDesign helps build stronger companies by democratising design and making it more productive</h1>
            <Carousel className="slider"    breakPoints={breakPoints} >
               {slides.map((image) =>{
                   return(
                       <div data-aos="fade-up"
                       data-aos-delay={100} className="image-part" style={{ backgroundImage: `url(${image})` }}>
                        <Play />
                       </div>
                   )
               })}
            </Carousel>
        </div>
    )
};
export default Banner ;